/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Ref_N3Inputs */

const en_to_typescript_ref_n3 = /** @type {(inputs: To_Typescript_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A nested object is lifted into its own interface, named from the key in PascalCase.`)
};

const ko_to_typescript_ref_n3 = /** @type {(inputs: To_Typescript_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중첩 객체는 키 이름을 PascalCase로 바꾼 자체 인터페이스로 올라갑니다.`)
};

const ja_to_typescript_ref_n3 = /** @type {(inputs: To_Typescript_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネストしたオブジェクトは、キー名を PascalCase にした独自インターフェースへ持ち上げられます。`)
};

/**
* | output |
* | --- |
* | "A nested object is lifted into its own interface, named from the key in PascalCase." |
*
* @param {To_Typescript_Ref_N3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_ref_n3 = /** @type {((inputs?: To_Typescript_Ref_N3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Ref_N3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_ref_n3(inputs)
	if (locale === "ko") return ko_to_typescript_ref_n3(inputs)
	return ja_to_typescript_ref_n3(inputs)
});